import React from 'react';

import { AdElement, AdvantagesWrapper, StarIcon } from '../styles';

import {
	redStar,
	blueStar,
	greenStar,
	turquoiseStar,
	redStar2x,
	blueStar2x,
	greenStar2x,
	turquoiseStar2x,
} from '../images';

const AD_TYPES = [
	{
		id: 0,
		bgColor: 'radial-gradient(50% 50% at 50% 50%, rgba(251, 152, 128, 0.3) 0%, rgba(254, 167, 143, 0.3) 100%)',
		text: 'Пакетные и розничные услуги по решению квартирного вопроса',
		icon: redStar,
		icon2x: redStar2x,
	},
	{
		id: 1,
		bgColor: 'linear-gradient(180deg, rgba(63, 137, 251, 0.2) 0%, rgba(58, 167, 254, 0.2) 100%)',
		text: 'Фиксированная цена на все услуги, которая не зависит от стоимости квартиры',
		icon: blueStar,
		icon2x: blueStar2x,
	},
	{
		id: 2,
		bgColor: 'linear-gradient(180deg, rgba(115, 188, 122, 0.2) 0%, rgba(138, 231, 159, 0.2) 100%)',
		text: 'Все условия прописаны в договоре с гарантией возврата денег',
		icon: greenStar,
		icon2x: greenStar2x,
	},

	{
		id: 3,
		bgColor: 'linear-gradient(180deg, rgba(0, 213, 213, 0.2) 0%, rgba(80, 233, 233, 0.2) 100%)',
		text: 'Мы отвечаем за всё, от начала до конца',
		icon: turquoiseStar,
		icon2x: turquoiseStar2x,
	},
];

const ServiceAdvantages = ({ isMobile }: boolean) => (
	<AdvantagesWrapper>
		{AD_TYPES.map((item) => (
			<AdElement key={item.id} bgColor={item.bgColor} isMobile={isMobile}>
				<StarIcon src={item.icon} srcSet={`${item.icon2x} 2x`} alt="Star" />
				<span style={{ margin: 0, padding: 0, gridArea: 'AdText' }}>{item.text}</span>
			</AdElement>
		))}
	</AdvantagesWrapper>
);

export default ServiceAdvantages;
